define([
    "dojo/_base/declare",
    "csi/xml",
    "csi/form/Widget"
], function(declare,xml,Widget) {

    return declare(Widget, {
        _parentType: null,

        isFieldEditable: function(/*Field*/field) {
            // summary: C8-2459 When inspection is passed or failed and is frozen
            // when on Saving as Template,the ‘Final Inspection’ cell should be editable in the dialog
            if (field.m_id == xml.ATTR_NAME)
                return true;
                
            return this.inherited(arguments);
        }
    });
});